"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapePrimitive = void 0;
const glme = require("../math/gl-matrix-extensions");
const ShapeBase_1 = require("./ShapeBase");
const Modifier_1 = require("../modifiers/Modifier");
const Adapt_1 = require("../modifiers/Adapt");
/**
 * @category Scene
 */
class ShapePrimitive extends ShapeBase_1.ShapeBase {
    /**
     * Creates an instance of ShapePrimitive.
     *
     * @param {IShapePrimitiveSettings} [settings={}]
     */
    constructor(settings = {}) {
        var _a;
        super(settings);
        /**
         * Contain the bounding of the last generated buffer
         *
         * @type {IShapeBounding}
         */
        this.currentGenerationPrimitiveBounding = Adapt_1.Bounding.empty();
        this.props.sideLength =
            typeof settings.sideLength === 'undefined'
                ? undefined
                : typeof settings.sideLength === 'function'
                    ? settings.sideLength
                    : glme.toVec2(settings.sideLength);
        this.drawer = settings.drawer || {};
        this.modifiers = settings.modifiers;
        this.bClosed = (_a = settings.bClosed) !== null && _a !== void 0 ? _a : true;
    }
    /**
     * Check if shape is static
     *
     * @returns {boolean}
     * @memberof ShapePrimitive
     */
    isStatic() {
        return typeof this.props.sideLength !== 'function' && super.isStatic();
    }
    /**
     * Return sideLength for current repetition
     *
     * @param propArguments
     * @returns
     */
    getRepetitionSideLength(propArguments) {
        if (this.bStatic) {
            // not set default value into constructor because it can be overridden by group
            if (typeof this.props.sideLength === 'undefined') {
                this.props.sideLength = [50, 50];
            }
            else if (typeof this.props.sideLength === 'number') {
                this.props.sideLength = [this.props.sideLength, this.props.sideLength];
            }
            return this.props.sideLength;
        }
        return glme.toVec2(this.getProp('sideLength', propArguments, [50, 50]));
    }
    /**
     * Apply modifiers on single repetition buffer
     *
     * @param buffer
     * @returns
     */
    applyModifiers(buffer, propArguments) {
        if (typeof this.modifiers === 'undefined')
            return buffer;
        let modified = buffer;
        const modifiers = Array.isArray(this.modifiers) ? this.modifiers : [this.modifiers];
        for (let i = 0, len = modifiers.length; i < len; i++) {
            const modifier = modifiers[i] instanceof Modifier_1.Modifier
                ? modifiers[i]
                : modifiers[i](propArguments);
            modified = modifier.apply(modified, this.bClosed, this);
        }
        return modified;
    }
    /**
     * Return a bounding of generated buffer if is direct scene child
     *
     * @returns {IShapeBounding}
     * @memberof ShapePrimitive
     */
    getShapeBounding() {
        return this.currentGenerationPrimitiveBounding;
    }
    /**
     * Add this to indexedBuffer
     *
     * @protected
     * @param {number} frameLength
     * @param {IRepetition} repetition
     * @returns {number} nextIndex
     */
    addIndex(frameLength, repetition, singleRepetitionBounding) {
        const index = {
            shape: this,
            frameLength,
            singleRepetitionBounding,
            repetition: {
                type: repetition.type,
                angle: repetition.angle,
                index: repetition.index,
                count: repetition.count,
                offset: repetition.offset,
                row: {
                    index: repetition.row.index,
                    count: repetition.row.count,
                    offset: repetition.row.offset,
                },
                col: {
                    index: repetition.col.index,
                    count: repetition.col.count,
                    offset: repetition.col.offset,
                },
            },
        };
        this.indexedBuffer.push(index);
    }
    /**
     * Return bClosed
     *
     * @returns {boolean}
     * @memberof ShapePrimitive
     */
    isClosed() {
        return this.bClosed;
    }
    /**
     * Set bClosed
     *
     * @param {boolean} bClosed
     * @memberof ShapePrimitive
     */
    setClosed(bClosed) {
        this.bClosed = bClosed;
    }
}
exports.ShapePrimitive = ShapePrimitive;
//# sourceMappingURL=ShapePrimitive.js.map